import { useContext } from 'react';

import { LocalizationContext } from './LocalizationScope';
import { useLanguage } from './useLanguage';

const treamsLanguages = [
	'nl_NL',
	'en_US',
	'fr_FR',
	'de_DE',
	'it_IT',
	'es_ES',
	'pt_BR',
	'da_DK',
	'sv_SE',
	'pl_PL',
];

export function useLocalize(): {
	localize: <T extends { languageID: string }>(items?: T[] | null, defaultValue?: T) => T;
	language: { id: string; loading: boolean };
	meta: {
		treamsLanguages: string[];
	};
} {
	const context = useContext(LocalizationContext);
	const defaultLanguage = useLanguage();
	const language = context?.languageID
		? { id: context.languageID, loading: false }
		: defaultLanguage;

	function localize<T extends { languageID: string }>(items?: T[] | null, defaultValue?: T): T {
		const optimized = items?.filter((item: { languageID: string; text?: string | unknown }) => {
			if ('text' in item && typeof item.text === 'string') {
				return item.text.length > 0;
			}

			return true;
		}) ?? [
			{
				languageID: language.id,
				text: undefined,
			},
		];

		return (optimized.find((item) => item.languageID === language.id) ??
			defaultValue ??
			optimized[0] ??
			items?.[0]) as T;
	}

	return { localize, language, meta: { treamsLanguages } };
}
